import angular from 'angular';
import modalCreateDelegationComponent from './modalCreateDelegation.component';
import createDelegationHelp from './createDelegationHelp/createDelegationHelp';

let modalCreateDelegationModule = angular.module('modalCreateDelegation', [
  createDelegationHelp
])

.component('modalCreateDelegation', modalCreateDelegationComponent)

.name;

export default modalCreateDelegationModule;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalCreateDelegation/modalCreateDelegation.js